import { observable, runInAction } from 'mobx';

const pendingTranscriptionCount = observable.box(0);

/** Register one upload; the returned release is safe to call more than once. */
export function trackPendingTranscription(): () => void {
  runInAction(() =>
    pendingTranscriptionCount.set(pendingTranscriptionCount.get() + 1)
  );

  let released = false;
  return function releasePendingTranscription() {
    if (released) return;
    released = true;
    runInAction(() =>
      pendingTranscriptionCount.set(pendingTranscriptionCount.get() - 1)
    );
  };
}

export function isTranscriptionPending(): boolean {
  return pendingTranscriptionCount.get() > 0;
}
